import { useEffect, useState } from "react";
import { navItems } from "@/mocks/home";

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const solid = scrolled || menuOpen;
  const textColor = solid ? "text-foreground-950" : "text-background-50";
  const logoColor = solid ? "text-foreground-950" : "text-background-50";

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        solid
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 md:h-[72px] items-center justify-between gap-4 px-4 md:px-8">
        <a href="#top" className={`flex shrink-0 items-center gap-2 ${logoColor}`}>
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-image-2-line text-lg" />
          </span>
          <span className="font-heading text-lg md:text-xl font-bold tracking-wide whitespace-nowrap">
            黑料图片
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-1">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className={`rounded-md px-3 py-2 text-sm font-medium whitespace-nowrap transition-colors hover:text-primary-500 ${textColor}`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <button
            type="button"
            aria-label="搜索"
            onClick={() => setSearchOpen((v) => !v)}
            className={`flex h-10 w-10 cursor-pointer items-center justify-center rounded-md transition-colors ${
              solid
                ? "text-foreground-700 hover:bg-background-100"
                : "text-background-50 hover:bg-background-50/15"
            }`}
          >
            <i className={searchOpen ? "ri-close-line text-xl" : "ri-search-line text-xl"} />
          </button>

          <a
            href="#download"
            className="hidden sm:inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-download-2-line text-base" />
            下载客户端
          </a>

          <button
            type="button"
            aria-label="菜单"
            onClick={() => setMenuOpen((v) => !v)}
            className={`flex h-10 w-10 cursor-pointer items-center justify-center rounded-md lg:hidden ${
              solid
                ? "text-foreground-800 hover:bg-background-100"
                : "text-background-50 hover:bg-background-50/15"
            }`}
          >
            <i className={menuOpen ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"} />
          </button>
        </div>
      </div>

      {searchOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 md:px-8">
          <div className="mx-auto flex max-w-xl items-center gap-2 rounded-md border border-background-300 bg-background-100 px-3 py-2">
            <i className="ri-search-line text-base text-foreground-400" />
            <input
              type="text"
              placeholder="搜实锤截图、聊天记录、证据截图…"
              className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
            />
          </div>
        </div>
      )}

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 lg:hidden">
          <nav className="flex flex-col px-4 py-2">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setMenuOpen(false)}
                className="flex items-center justify-between border-b border-background-100 py-3 text-sm font-medium text-foreground-800"
              >
                {item.label}
                <i className="ri-arrow-right-s-line text-foreground-400" />
              </a>
            ))}
            <a
              href="#download"
              onClick={() => setMenuOpen(false)}
              className="mt-4 mb-3 inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 px-4 py-3 text-sm font-semibold text-background-50"
            >
              <i className="ri-download-2-line text-base" />
              下载客户端
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}